import { render, staticRenderFns } from "./CrgoPort.vue?vue&type=template&id=73eae9d2&"
import script from "./CrgoPort.vue?vue&type=script&lang=js&"
export * from "./CrgoPort.vue?vue&type=script&lang=js&"
import style0 from "./CrgoPort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoPort.vue"
export default component.exports